export default __webpack_public_path__ + "static/media/zeiptreceipt.86a05b83.svg";